import axios from 'axios'
import {Message} from "element-ui";

// let host = 'http://www.uukasi.com:8088'
let host = 'https://uukasi.com'
// let host = 'http://localhost:8001'

axios.interceptors.request.use(
  config => {
    if (localStorage.getItem('iiucasToken')) {
      // // 判断是否存在最后一个时间
      // let lastTime = localStorage.getItem('lastPost') || null
      // let nowTime = Date.now()
      // if (!lastTime){
      //   localStorage.setItem('lastPost', nowTime)
      //   lastTime = nowTime
      // }
      // let logOutTime = localStorage.getItem('logout-time') || 30
      // if(nowTime - Number(lastTime)>= (Number(logOutTime)*60*1000)){
      // //  退出
      //   localStorage.removeItem('lastPost')
      //   localStorage.removeItem('iiucasToken')
      //   localStorage.removeItem('userInfo')
      //   if(config.url.indexOf('login')===-1){
      //     Message.warning('登录超时')
      //     //更新store数据
      //     // this.$store.dispatch('setInfo');
      //     location.reload()
      //   }
      // }else {
      //   localStorage.setItem('lastPost', nowTime)
      // }
      config.headers.Authorization = localStorage.getItem('iiucasToken')
    }

    return config
  },
  error => {
    return Promise.reject(error)
  })

// 登录
export const login = params => {
  return axios.post(`${host}/login/`, params)
}
// 短信验证登录 验证码
export const loginCodes = parmas => {
  return axios.post(`${host}/lcode/`, parmas)
}
// 短信验证登录
export const verifyLogin = params => {
  return axios.post(`${host}/clogin/`, params)
}
// 三方绑定
export const bindLogin = params => {
  return axios.post(`${host}/bind-login/`, params)
}

// 退出登录时长
export const logoutTime = params => {
  return axios.get(`${host}/logout-time/`, {params: params})
}

// 首页列表（排序）
export const newIndexOrder = params => {
  return axios.get(`${host}/new-index-order/`, {params: params})
}
// 用户首页排序
export const userIndexOrdering = params => {
  return axios.get(`${host}/user-index-ordering/`, {params: params})
}
//用户编辑首页排序
export const indexOrderingChange = parmas => {
  return axios.post(`${host}/index-ordering-change/`, parmas)
}
// 首页推荐视频个数
export const videoRecommendList = params => {
  return axios.get(`${host}/video-recommend-list/`, {params: params})
}
// 密码错误次数管理
export const errorManageList = params => {
  return axios.get(`${host}/error-manage-list/`, {params: params})
}
// 视频分类
export const newClassifyVideo = params => {
  return axios.get(`${host}/new-classify-video/`, {params: params})
}
// 视频小分类
export const newClassifySmall = params => {
  return axios.get(`${host}/new-classify-small/`, {params: params})
}

// 视频推荐
export const videoRecommend = params => {
  return axios.get(`${host}/video/recommend/`, {params: params})
}

// 获取用户信息
export const getUserDetail = params => {
  return axios.get(`${host}/user/detail/`, {params: params})
}
// 获取用户ip
export const getUserIp = params => {
  return axios.get(`${host}/user-ip/`, {params: params})
}


// 视频内容管理列表
export const videoManage = params => {
  return axios.get(`${host}/new-video-manage-list/`, {params: params})
}
// 视频内容管理列表
export const videoManageDetail = params => {
  return axios.get(`${host}/new-video-manage-detail/`, {params: params})
}
// 视频的列表
export const videoVideo = params => {
  return axios.get(`${host}/video/video/`, {params: params})
}
// 视频每一集获取视频
export const getEachVideo = params => {
  return axios.get(`${host}/lkvideo/`, {params: params})
}
// 视频列表、视频详情
export const videolistorDetail = params => {
  return axios.get(`${host}/videotitle/`, {params: params})
}
// 删除视频稿件
export const videoDelManu = parmas => {
  return axios.post(`${host}/video/delManu/`, parmas)
}
// 视频新作->旧作
export const videoNewOld = parmas => {
  return axios.post(`${host}/video/new-old/`, parmas)
}

// 获取视频分区
export const classifyVideo = params => {
  return axios.get(`${host}/new-classify-video/`, {params: params})
}
// 获取视频分区推荐
export const labelRecommendedVideo = params => {
  return axios.get(`${host}/new-label-recommended-video/`, {params: params})
}
// 获取视频分区 活动
export const labelActivityVideo = params => {
  return axios.get(`${host}/new-label-activity-video/`, {params: params})
}
// 获取视频标签
export const videoToLabel = params => {
  return axios.get(`${host}/new-video-to-label/`, {params: params})
}
// 获取视频字幕语言列表
export const languageVideo = params => {
  return axios.get(`${host}/new-video-language/`, {params: params})
}
// 获取视频字幕语言列表
export const templateVideoList = params => {
  return axios.get(`${host}/new-video-template-list/`, {params: params})
}
// 更新视频稿件
export const templateVideoUpdate = parmas => {
  return axios.post(`${host}/new-video-template-update/`, parmas)
}
// 删除视频稿件
export const templateVideoDel = parmas => {
  return axios.post(`${host}/new-video-template-del/`, parmas)
}
// 视频封面上传
export const videoPimg = parmas => {
  return axios.post(`${host}/video/pimg/`, parmas)
}
// 视频投稿
export const videoPublication = parmas => {
  return axios.post(`${host}/video/publication/`, parmas)
}
// oss上传视频签名
export const ossVideo = params => {
  return axios.get(`${host}/ossVideo/`, {params: params})
}
// oss上传保存url数据
export const ossVideoPost = params => {
  return axios.post(`${host}/ossVideoPost/`, params)
}
// 删除视频
export const videoDelFile = parmas => {
  return axios.post(`${host}/vidoe/delFile/`, parmas)
}
// 获取视频的url
export const videolkvideo = params => {
  return axios.get(`${host}/lkvideo/`, {params: params})
}

// 视频字幕列表
export const videoSubtitlesList = params => {
  return axios.get(`${host}/video-subtitles-list/`, {params: params})
}
// 视频列表
export const videoListSearch = params => {
  return axios.get(`${host}/video-list-search/`, {params: params})
}

// 文集添加
export const columnCorpusAdd = parmas => {
  return axios.post(`${host}/column-corpus-add/`, parmas)
}
// 文集改变文章排序
export const corpusIndex = parmas => {
  return axios.post(`${host}/corpus-index/`, parmas)
}
// 文章专栏分类
export const articleTopicType = params => {
  return axios.get(`${host}/new-topic-type/`, {params: params})
}
// 文章标签
export const classifyArticleList = params => {
  return axios.get(`${host}/classify-article-list/`, {params: params})
}
// 文章标签
export const classifyArticleSmallList = params => {
  return axios.get(`${host}/classify-article-small-list/`, {params: params})
}
// 文集列表
export const columnCorpusList = params => {
  return axios.get(`${host}/column-corpus-list/`, {params: params})
}
// 文集详情
export const corpusDetail = params => {
  return axios.get(`${host}/corpus-detail/`, {params: params})
}
// 文集详情
export const articleAppendList = params => {
  return axios.get(`${host}/article-append-list/`, {params: params})
}
// 文章插入卡片列表
export const articleCardList = params => {
  return axios.get(`${host}/article-card-list/`, {params: params})
}
// 上传图片   文章专栏
export const PImg = parmas => {
  return axios.post(`${host}/pimg/`, parmas)
}
// 添加投票
export const votePost = parmas => {
  return axios.post(`${host}/vote-post/`, parmas)
}
// 文章投票列表
export const voteList = params => {
  return axios.get(`${host}/vote-list/`, {params: params})
}
// 文章投票详情
export const voteDetail = params => {
  return axios.get(`${host}/vote-detail/`, {params: params})
}
// 文章保存、发布
export const articlePost = params => {
  return axios.post(`${host}/article-post/`, params)
}
// 文章列表
export const ArticleList = params => {
  return axios.get(`${host}/article-list/`, {params: params})
}

// 草稿列表
export const userCaogaoList = parmas => {
  return axios.get(`${host}/forum/savelist/`, {params: parmas})
}
// 删除草稿
export const userSaveDel = parmas => {
  return axios.post(`${host}/forum/savedel/`, parmas)
}
// 文章detail
export const columnArticlesDetail = params => {
  return axios.get(`${host}/forum/articleDetail/`, {params: params})
}
// 文章管理-数据
export const articleData = params => {
  return axios.get(`${host}/article-data/`, {params: params})
}
// 文章加入文集
export const articleAddCorpus = params => {
  return axios.post(`${host}/article-add-corpus/`, params)
}
// 删除文章
export const articleDel = params => {
  return axios.post(`${host}/forum/articleDel/`, params)
}
// 移除文集内的文章
export const removeCorpusArticle = params => {
  return axios.post(`${host}/remove-corpus-article/`, params)
}
// 删除文集
export const delCorpus = params => {
  return axios.post(`${host}/del-corpus/`, params)
}


// 获取用户关注列表
export const userAttentionList = params => {
  return axios.get(`${host}/new-user-attention-list/`, {params: params})
}
// 获取用户关注数
export const userAttentionNum = params => {
  return axios.get(`${host}/user-attention-num/`, {params: params})
}
// 关注用户-取消关注
export const userAttentionPost = params => {
  return axios.post(`${host}/user-attention-post/`, params)
}

// 获取用户收藏夹列表
export const favoriteList = params => {
  return axios.get(`${host}/favorite-list/`, {params: params})
}
// 新建用户收藏夹列表
export const favoritePost = params => {
  return axios.post(`${host}/favorite-post/`, params)
}
// 用户收藏夹删除
export const favoriteDel = params => {
  return axios.post(`${host}/favorite-del/`, params)
}



// 用户音频合集列表
export const audioCompilationsList = params => {
  return axios.get(`${host}/audio-compilations-list/`, {params: params})
}
// 用户音频合集详情
export const audioCompilationsDetail = params => {
  return axios.get(`${host}/audio-compilations-detail/`, {params: params})
}
// 用户可关联视频列表
export const relatedVideoList = params => {
  return axios.get(`${host}/related-video-list/`, {params: params})
}
// 用户音频提交
export const audioPost = params => {
  return axios.post(`${host}/audio-post/`, params)
}
// 用户音频合集提交
export const audioCompilationsPost = params => {
  return axios.post(`${host}/audio-compilations-post/`, params)
}
// 用户音频合集删除
export const audioCompilationsDelete = params => {
  return axios.post(`${host}/audio-compilations-delete/`, params)
}
// 用户音乐加入合集
export const audioUpdateCompilations = params => {
  return axios.post(`${host}/audio-update-compilations/`, params)
}
// 删除音乐
export const audioDelete = params => {
  return axios.post(`${host}/audio-delete/`, params)
}
// 用户音频合集列表
export const audioList = params => {
  return axios.get(`${host}/audio-list/`, {params: params})
}
// 用户音频合集列表
export const audioDetail = params => {
  return axios.get(`${host}/audio-detail/`, {params: params})
}


// 管理-视频分类
export const videoManageClassify = params => {
  return axios.get(`${host}/video-manage-classify/`, {params: params})
}
// 管理-视频数据分析
export const videoDataDetail = params => {
  return axios.get(`${host}/video-data-detail/`, {params: params})
}
// 管理-视频卡片列表
export const videoCardList = params => {
  return axios.get(`${host}/video-card-list/`, {params: params})
}
// 管理-视频卡片添加
export const videoCardCreate = params => {
  return axios.post(`${host}/video-card-create/`, params)
}
// 管理-视频卡片删除
export const videoCardDel = params => {
  return axios.post(`${host}/video-card-del/`, params)
}
// 管理-视频设置公开私密
export const videoAnonymous = parmas => {
  return axios.post(`${host}/video/anonymous/`, parmas)
}


//数据分析-视频
export const videoDataCenterAll = params => {
  return axios.get(`${host}/video-data-center-all/`, {params: params})
}
//数据分析-视频
export const videoDataCenterDetail = params => {
  return axios.get(`${host}/video-data-center-detail/`, {params: params})
}
//数据分析-播放
export const playDataCenterAllDistribute = params => {
  return axios.get(`${host}/play-data-center-all-distribute/`, {params: params})
}
//数据分析-播放来源
export const playDataCenterAllManuscript = params => {
  return axios.get(`${host}/play-data-center-all-manuscript/`, {params: params})
}
//数据分析-播放来源
export const playDataCenterAllTime = params => {
  return axios.get(`${host}/play-data-center-all-time/`, {params: params})
}
//数据分析-粉丝
export const fansDataCenterAll = params => {
  return axios.get(`${host}/fans-data-center-all/`, {params: params})
}
//数据分析-粉丝画像
export const fansDataCenterPortrayal = params => {
  return axios.get(`${host}/fans-data-center-portrayal/`, {params: params})
}
//数据分析-文章
export const articleDataCenter = params => {
  return axios.get(`${host}/article-data-center/`, {params: params})
}


//评论管理-视频
export const videoManageCommentList = params => {
  return axios.get(`${host}/video-comment-list/`, {params: params})
}
//评论管理-回复
export const videoCommentPost = parmas => {
  return axios.post(`${host}/video/comment/`, parmas)
}
//评论管理-点赞
export const videoCommentLike = params => {
  return axios.get(`${host}/video/like/`, {params: params})
}
//评论管理-举报
export const videoComplaintPost = parmas => {
  return axios.post(`${host}/video/complaint/`, parmas)
}
//评论管理-删除
export const videoDelPost = parmas => {
  return axios.post(`${host}/video/del/`, parmas)
}

//评论管理-文章
export const articleCommentList = params => {
  return axios.get(`${host}/article-comment-list/`, {params: params})
}
//评论管理-回复
export const articleCommentPost = parmas => {
  return axios.post(`${host}/forum/articomment/`, parmas)
}
//评论管理-点赞，文章点赞
export const articleCommentLike = params => {
  return axios.get(`${host}/forum/like/`, {params: params})
}
//评论管理-举报
export const articleComplaintPost = parmas => {
  return axios.post(`${host}/forum/complaint/`, parmas)
}
//评论管理-删除
export const articleDelPost = parmas => {
  return axios.post(`${host}/forum/delcommont/`, parmas)
}

//评论管理-音频
export const audioCommentList = params => {
  return axios.get(`${host}/audio-comment-list/`, {params: params})
}
//评论管理-回复
export const audioCommentPost = parmas => {
  return axios.post(`${host}/audio-comment-post/`, parmas)
}
//评论管理-点赞
export const audioCommentLike = params => {
  return axios.post(`${host}/audio-comment-like/`, params)
}
//评论管理-举报
export const audioComplaintPost = parmas => {
  return axios.post(`${host}/audio-complaint-post/`, parmas)
}
//评论管理-删除
export const audioCommentDel = parmas => {
  return axios.post(`${host}/audio-comment-del/`, parmas)
}

//弹幕管理-列表
export const barrageList = parmas => {
  return axios.get(`${host}/barrage-list/`, {params: parmas})
}
//弹幕管理-删除
export const barrageDel = parmas => {
  return axios.post(`${host}/barrage-del/`, parmas)
}
//弹幕管理-保护
export const barrageProtect = parmas => {
  return axios.post(`${host}/barrage-protect/`, parmas)
}
//弹幕管理-类型
export const barrageTypes = parmas => {
  return axios.post(`${host}/barrage-types/`, parmas)
}
//弹幕管理-点赞
export const barrageLike = parmas => {
  return axios.post(`${host}/barrage-like/`, parmas)
}

//弹幕设置-列表
export const barrageSettingList = parmas => {
  return axios.get(`${host}/barrage-setting-list/`, {params: parmas})
}
//弹幕管理-修改
export const barrageSettingChange = parmas => {
  return axios.post(`${host}/barrage-setting-change/`, parmas)
}
//弹幕管理-添加关键词
export const barrageFiltrationAdd = parmas => {
  return axios.post(`${host}/barrage-filtration-add/`, parmas)
}
//弹幕管理-删除关键词
export const barrageFiltrationDel = parmas => {
  return axios.post(`${host}/barrage-filtration-del/`, parmas)
}

//弹幕设置-视频列表
export const barrageFeedbackVideo = parmas => {
  return axios.get(`${host}/barrage-feedback-video/`, {params: parmas})
}
//弹幕设置-举报列表
export const barrageReportList = parmas => {
  return axios.get(`${host}/barrage-report-list/`, {params: parmas})
}
//弹幕设置-高级请求列表
export const barrageHighList = parmas => {
  return axios.get(`${host}/barrage-high-list/`, {params: parmas})
}
//弹幕设置-保护请求列表
export const barrageProtectList = parmas => {
  return axios.get(`${host}/barrage-protect-list/`, {params: parmas})
}
//弹幕管理-忽略举报
export const barrageReportResults = parmas => {
  return axios.post(`${host}/barrage-report-results/`, parmas)
}
//弹幕管理-取消授权
export const barrageHighResults = parmas => {
  return axios.post(`${host}/barrage-high-results/`, parmas)
}
//弹幕管理-取消保护
export const barrageProtectResults = parmas => {
  return axios.post(`${host}/barrage-protect-results/`, parmas)
}

//用户收益-电磁力
export const userElectromagnetism = parmas => {
  return axios.get(`${host}/user-electromagnetism/`, {params: parmas})
}
//用户收益-榜样列表
export const electromagnetismList = parmas => {
  return axios.get(`${host}/electromagnetism-list/`, {params: parmas})
}
//用户收益-申请开通创作激励
export const excitationApplyPost = parmas => {
  return axios.post(`${host}/excitation-apply-post/`, parmas)
}
//用户收益-开通电磁力
export const electromagnetismPost = parmas => {
  return axios.post(`${host}/electromagnetism-post/`, parmas)
}
//用户收益-信用分
export const creditDetail = parmas => {
  return axios.get(`${host}/credit-detail/`, {params: parmas})
}
//用户收益-充电计划
export const chargeList = parmas => {
  return axios.get(`${host}/charge-list/`, {params: parmas})
}
//用户收益-开通充电计划
export const chargeCreate = parmas => {
  return axios.post(`${host}/charge-create/`, parmas)
}
//用户收益-开通充电通知
export const chargeInform = parmas => {
  return axios.post(`${host}/charge-inform/`, parmas)
}
//用户收益-悬赏判断是否可开通
export const rewardCondition = parmas => {
  return axios.get(`${host}/reward-condition/`, {params: parmas})
}
//用户收益-悬赏状态
export const rewardStatus = parmas => {
  return axios.get(`${host}/reward-status/`, {params: parmas})
}
//用户收益-申请悬赏
export const rewardApply = parmas => {
  return axios.post(`${host}/reward-apply/`, parmas)
}
//用户收益-花火状态
export const petardStatus = parmas => {
  return axios.get(`${host}/petard-status/`, {params: parmas})
}
//用户收益-花火悬赏
export const petardApply = parmas => {
  return axios.post(`${host}/petard-apply/`, parmas)
}
//用户拉黑
export const blacklistAdd = parmas => {
  return axios.post(`${host}/blacklist-add/`, parmas)
}


//创作管理设置列表
export const creationSettingList = parmas => {
  return axios.get(`${host}/creation-setting-list/`, {params: parmas})
}
//创作管理设置 开关
export const creationSettingPost = parmas => {
  return axios.post(`${host}/creation-setting-post/`, parmas)
}

//视频页弹幕列表
export const videoBarrage = params => {
  return axios.get(`${host}/video-barrage/`, {params: params})
}
//发送弹幕
export const videoBarragePost = parmas => {
  return axios.post(`${host}/barragePost/`, parmas)
}
//视频偏好设置列表
export const barragePreferenceList = params => {
  return axios.get(`${host}/barrage-preference-list/`, {params: params})
}
//视频偏好设置
export const barragePreferenceChange = parmas => {
  return axios.post(`${host}/barrage-preference-change/`, parmas)
}
//视频弹幕撤回
export const barrageCancel= parmas => {
  return axios.post(`${host}/barrage-cancel/`, parmas)
}
//视频播放器问题反馈
export const playerFeedback= parmas => {
  return axios.post(`${host}/player-feedback/`, parmas)
}
//视频举报弹幕
export const barrageReportPost= parmas => {
  return axios.post(`${host}/barrage-report-post/`, parmas)
}
//视频屏蔽弹幕、取消
export const barrageShieldPost= parmas => {
  return axios.post(`${host}/barrage-shield-post/`, parmas)
}
//视频屏蔽列表开关
export const barrageShieldSwitch= parmas => {
  return axios.post(`${host}/barrage-shield-switch/`, parmas)
}
//视频弹幕屏蔽列表
export const barragesShieldList = params => {
  return axios.get(`${host}/barrage-shield-list/`, {params: params})
}

//视频添加历史记录，增加点击量
export const videoAddHistory = params => {
  return axios.get(`${host}/video/vclick/`, {params: params})
}
// 用户视频记录
export const lookAndHistory = params => {
  return axios.get(`${host}/history/`, {params: params})
}
// 用户删除视频记录
export const delHistory = params => {
  return axios.get(`${host}/userop/delhistory/`, {params: params})
}
// 用户专栏历史记录
export const articleHistory = params => {
  return axios.get(`${host}/article-history/`, {params: params})
}
// 用户删除专栏记录
export const delArticleHistory = params => {
  return axios.get(`${host}/article-history-del/`, {params: params})
}
// 视频观看时间记录
export const videoLookTime = params => {
  return axios.get(`${host}/video/lookTime/`, {params: params})
}
// 视频正在看人数增加、减少
export const videoLookNum = parmas => {
  return axios.post(`${host}/video/lookNum/`, parmas)
}
// 视频点赞
export const videoLike = parmas => {
  return axios.post(`${host}/video-like/`, parmas)
}
// 视频收藏
export const videoFav = parmas => {
  return axios.post(`${host}/video-fav/`, parmas)
}
// 视频投币
export const videoCoin = parmas => {
  return axios.post(`${host}/video-coin/`, parmas)
}
// 视频分享
export const videoShare = parmas => {
  return axios.post(`${host}/video-share/`, parmas)
}
// 视频稿件投诉，视频评论投诉
export const videoComplaint = parmas => {
  return axios.post(`${host}/video/complaint/`, parmas)
}
// 视频稍后观看
export const videoLater = parmas => {
  return axios.post(`${host}/video-later/`, parmas)
}
// 视频稍后观看
export const videoBingeWatch = parmas => {
  return axios.post(`${host}/video-binge-watch/`, parmas)
}
// 视频评论的列表
export const videoCommentList = params => {
  return axios.get(`${host}/video/commentlist/`, {params: params})
}
// 视频评论的查看更多
export const videoCommentDetail = params => {
  return axios.get(`${host}/video/commentdetail/`, {params: params})
}
// 购买视频消耗积分提示
export const buyVideoTakeHowManyScore = params => {
  return axios.get(`${host}/payvideo/`, {params: params})
}
// 最终购买视频
export const buyEndVideo = params => {
  return axios.get(`${host}/venter/`, {params: params})
}

// 充值生成订单接口
export const chargePoint = params => {
  return axios.get(`${host}/vuser/order/`, {params: params})
}
// 循环查询微信是否支付成功
export const payCheckOrder = params => {
  return axios.get(`${host}/vuser/wei/order/`, {params: params})
}
// B币充电
export const chargeOrder = params => {
  return axios.post(`${host}/charge-order/`, params)
}

// 判断微信关注
export const judgeWechatFollow = parmas => {
  return axios.get(`${host}/public/userinfo/`, {params: parmas})
}
// 积分
export const myucasIntegral = parmas => {
  return axios.get(`${host}/integral/`, {params: parmas})
}
// 会员
export const myucasVipjuris = parmas => {
  return axios.get(`${host}/vipjuris/`, {params: parmas})
}


// 文章列表
export const articleList = parmas => {
  return axios.get(`${host}/forum/articlelist/`, {params: parmas})
}
// 文章排行榜
export const articleRanking = parmas => {
  return axios.get(`${host}/article-ranking/`, {params: parmas})
}
// 最新发文用户排行榜
export const upRanking = parmas => {
  return axios.get(`${host}/up-ranking/`, {params: parmas})
}
// 专栏的文章推荐
export const recommendArticle = params => {
  return axios.get(`${host}/forum/recommend/`, {params: params})
}
// 文章点击量
export const articleAddClick = params => {
  return axios.get(`${host}/forum/click/`, {params: params})
}
// 专栏下的历史记录
export const articleAddHistory = params => {
  return axios.get(`${host}/forum/history/`, {params: params})
}
// 收藏
export const articleCollect = params => {
  return axios.get(`${host}/forum/collect/`, {params: params})
}
// 文章投币
export const articleCoin = parmas => {
  return axios.post(`${host}/article-coin/`, parmas)
}
// 专栏文章的评论列表
export const articlePageCommentList = params => {
  return axios.get(`${host}/forum/articleCommentList/`, {params: params})
}
// 专栏文章的评论列表查看更多
export const articleCommentMore = params => {
  return axios.get(`${host}/forum/articleComment/`, {params: params})
}
// 投票
export const voteConPost = params => {
  return axios.post(`${host}/voteCon-post/`, params)
}


// 音频详情页的详情
export const audioDetailAll = params => {
  return axios.get(`${host}/audio-detail-all/`, {params: params})
}
// 音频投币
export const audioCoin = parmas => {
  return axios.post(`${host}/audio-coin/`, parmas)
}
// 音频加入歌单
export const audioSongListAdd = parmas => {
  return axios.post(`${host}/audio-songList-add/`, parmas)
}
// 音频合集加入收藏
export const audioCollectFav = parmas => {
  return axios.post(`${host}/audio-collect-fav/`, parmas)
}
// 音频页评论
export const audioCommentRoot = params => {
  return axios.get(`${host}/audio-comment-root/`, {params: params})
}
// 音频详情页的详情
export const audioTitleAll = params => {
  return axios.get(`${host}/audio-title-all/`, {params: params})
}
// 我的歌单
export const userSongList = params => {
  return axios.get(`${host}/user-song-list/`, {params: params})
}
// 我的收藏合集
export const userFavAudioList = params => {
  return axios.get(`${host}/user-fav-audio-list/`, {params: params})
}
// 热门歌单
export const hotSongList = params => {
  return axios.get(`${host}/hot-song-list/`, {params: params})
}

// 搜索关键词列表
export const searchWordList = params => {
  return axios.get(`${host}/search-word-list/`, {params: params})
}
// 搜索-数量
export const searchCount = params => {
  return axios.get(`${host}/search-count/`, {params: params})
}
// 搜索-用户
export const searchUser = params => {
  return axios.get(`${host}/search-user/`, {params: params})
}
// 搜索-视频
export const searchVideo = params => {
  return axios.get(`${host}/search-video/`, {params: params})
}
// 搜索-番剧-多视频
export const searchSeries = params => {
  return axios.get(`${host}/search-series/`, {params: params})
}
// 搜索-番剧-多视频
export const searchArticle = params => {
  return axios.get(`${host}/search-article/`, {params: params})
}
// 搜索-热搜
export const searchHotWordList = params => {
  return axios.get(`${host}/forum/search/`, {params: params})
}

// 用户个人中心 信息详情
export const peopleDetail = params => {
  return axios.get(`${host}/forum/userList/`, {params: params})
}
// 用户个人中心 相关数量
export const homeNumber = params => {
  return axios.get(`${host}/home-number/`, {params: params})
}
// 用户个人中心 视频分区列表
export const homeVideoClassify = params => {
  return axios.get(`${host}/home-video-classify/`, {params: params})
}
// 用户个人中心 视频列表
export const homeVideo = params => {
  return axios.get(`${host}/home-video/`, {params: params})
}
// 用户个人中心 专栏列表
export const homeArticle = params => {
  return axios.get(`${host}/home-article/`, {params: params})
}
// 用户个人中心 文集列表
export const homeCorpus = params => {
  return axios.get(`${host}/home-corpus/`, {params: params})
}
// 用户个人中心 音频列表
export const homeAudio = params => {
  return axios.get(`${host}/home-audio/`, {params: params})
}
// 用户个人中心 音频合辑列表
export const homeAudioCollect = params => {
  return axios.get(`${host}/home-audio-collect/`, {params: params})
}
// 用户个人中心 收藏夹列表
export const homeFavorites = params => {
  return axios.get(`${host}/home-favorites/`, {params: params})
}
// 用户个人中心 收藏夹内容
export const homeFavoritesDetail = params => {
  return axios.get(`${host}/home-favorites-detail/`, {params: params})
}
// 用户个人中心 收藏夹移动、复制
export const homeFavoritesCopy = params => {
  return axios.post(`${host}/home-favorites-copy/`, params)
}
// 用户个人中心 追番列表
export const homeBingeWatch = params => {
  return axios.get(`${host}/home-binge-watch/`, {params: params})
}
// 用户个人中心 投币列表
export const homeVideoCoin = params => {
  return axios.get(`${host}/home-video-coin/`, {params: params})
}
// 用户个人中心 点赞列表
export const homeVideoLike = params => {
  return axios.get(`${host}/home-video-like/`, {params: params})
}
// 用户个人中心 置顶
export const homeVideoTopPost = params => {
  return axios.post(`${host}/home-video-top-post/`, params)
}
// 用户个人中心 置顶列表
export const homeVideoTopList = params => {
  return axios.get(`${host}/home-video-top-list/`, {params: params})
}
// 用户个人中心 取消置顶
export const homeVideoTopDel = params => {
  return axios.post(`${host}/home-video-top-del/`, params)
}

// 稍后再看-列表
export const videoLaterList = params => {
  return axios.get(`${host}/video-later-list/`, {params: params})
}
// 稍后再看-删除
export const videoLaterDel = params => {
  return axios.post(`${host}/video-later-del/`, params)
}
// 稍后再看-改变状态
export const videoLaterChange = params => {
  return axios.post(`${host}/video-later-change/`, params)
}

// 个人空间设置
export const userSpaceSettingList = params => {
  return axios.get(`${host}/user-space-setting-list/`, {params: params})
}
// 个人空间设置
export const userSpaceSettingPost = params => {
  return axios.post(`${host}/user-space-setting-post/`, params)
}
// 个人空间排序
export const userSpaceOrderingList = params => {
  return axios.get(`${host}/user-space-ordering-list/`, {params: params})
}
// 个人空间排序
export const userSpaceOrderingPost = params => {
  return axios.post(`${host}/user-space-ordering-post/`, params)
}
// 个人空间公告
export const userAnnouncementPost = params => {
  return axios.post(`${host}/user-announcement-post/`, params)
}
// 获取微信的东西
export const getSignPackage = parmas => {
  return axios.get(`${host}/getSignPackage/`, {params: parmas})
}
// 广告
export const advert = (params) => {
  return axios.get(`${host}/advert/`, {params: params})
}
export const imageCollect = (params) => {
  return axios.get(`${host}/image-collect/`, {params: params})
}

// vip头像挂件
export const vipFaceList = (params) => {
  return axios.get(`${host}/vip-face-list/`, {params: params})
}
// 用户添加经验值
export const addExperience = params => {
  return axios.post(`${host}/add-experience/`, params)
}
// 个人中心首页数据
export const userCenterIndex = (params) => {
  return axios.get(`${host}/user-center-index/`, {params: params})
}
// 提交用户个人信息
export const queryUserInfoDetl = parmas => {
  return axios.post(`${host}/detail/`, parmas)
}
// 黑名单列表
export const blackRoomList = (params) => {
  return axios.get(`${host}/black-room-list/`, {params: params})
}
// 硬币记录
export const coinRecord = (params) => {
  return axios.get(`${host}/coin-record/`, {params: params})
}
// 用户登录记录
export const userLoginRecord = (params) => {
  return axios.get(`${host}/user-login-record/`, {params: params})
}
// 用户经验记录
export const experienceRecord = (params) => {
  return axios.get(`${host}/experience-record/`, {params: params})
}
// 用户实名认证信息
export const userRealnameList = (params) => {
  return axios.get(`${host}/user-realname-list/`, {params: params})
}
// 提交实名认证发送验证码
export const RealNameCode = parmas => {
  return axios.post(`${host}/ucode/`, parmas)
}
// 提交实名认证
export const userRealnameCreate = parmas => {
  return axios.post(`${host}/user-realname-create/`, parmas)
}
// 用户b币列表
export const bCoinList = (params) => {
  return axios.get(`${host}/bCoin-list/`, {params: params})
}
// 用户vip开通记录
export const vipOrderList = (params) => {
  return axios.get(`${host}/vip-order-list/`, {params: params})
}
// 换头像
export const headimg = parmas => {
  return axios.post(`${host}/headimg/`, parmas)
}
// 兑换头像
export const userFaceExchange = parmas => {
  return axios.post(`${host}/user-face-exchange/`, parmas)
}
// 我的挂件列表
export const userFaceList = (params) => {
  return axios.get(`${host}/user-face-list/`, {params: params})
}
// 装饰头像
export const userFaceActive = parmas => {
  return axios.post(`${host}/user-face-active/`, parmas)
}
// 验证码验证
export const CodeTest = params => {
  return axios.post(`${host}/codesuc/`, params)
}
// 绑定邮箱
export const userBindMail = params => {
  return axios.post(`${host}/user-bind-mail/`, params)
}
// 绑定手机号
export const userBindPhone = params => {
  return axios.post(`${host}/user-bind-phone/`, params)
}
// 密保设置
export const securityProtectionCreate = params => {
  return axios.post(`${host}/security-protection-create/`, params)
}
// 密码设置
export const forgetPassword = params => {
  return axios.post(`${host}/forget/`, params)
}
// 三方解绑
export const binddelsfzh = params => {
  return axios.post(`${host}/binddelsfzh/`, params)
}

// 我的回复列表
export const messageDevelopmentList = (params) => {
  return axios.get(`${host}/message-development-list/`, {params: params})
}
// 我的赞列表
export const likeDevelopmentList = (params) => {
  return axios.get(`${host}/like-development-list/`, {params: params})
}
// 我的at列表
export const atDevelopmentList = (params) => {
  return axios.get(`${host}/at-development-list/`, {params: params})
}
// 消息列表删除
export const developmentDel = params => {
  return axios.post(`${host}/development-del/`, params)
}

// 我的私信好友列表
export const friendMessage = (params) => {
  return axios.get(`${host}/forum/friend/`, {params: params})
}
// 私信列表
export const PrivateLatter = (params) => {
  return axios.get(`${host}/forum/privateLatter/`, {params: params})
}
// 私信数量
export const latterCount = (params) => {
  return axios.get(`${host}/forum/latterCount/`, {params: params})
}
// 发送消息
export const latterPost = params => {
  return axios.post(`${host}/forum/latterPost/`, params)
}
// 删除消息
export const delLatter = params => {
  return axios.post(`${host}/forum/delLatter/`, params)
}
// 删除好友对话
export const delFriend = params => {
  return axios.post(`${host}/forum/delFriend/`, params)
}

// 用户消息提醒列表
export const messageConfigList = (params) => {
  return axios.get(`${host}/message-config-list/`, {params: params})
}
// 用户消息提醒设置
export const messageConfigPost = params => {
  return axios.post(`${host}/message-config-post/`, params)
}
// 用户消息提醒清零
export const messageConfigReset = params => {
  return axios.post(`${host}/message-config-reset/`, params)
}

// 用户动态列表
export const dynamicList = (params) => {
  return axios.get(`${host}/dynamic-list/`, {params: params})
}

// 动态发布
export const dynamicPost = params => {
  return axios.post(`${host}/dynamic-post/`, params)
}
// 专栏轮播文章
export const articleCarouselList = (params) => {
  return axios.get(`${host}/article-carousel-list/`, {params: params})
}
// 音乐列表
export const audioAllList = (params) => {
  return axios.get(`${host}/audio-all-list/`, {params: params})
}
// 合集列表
export const audioTitleAllList = (params) => {
  return axios.get(`${host}/audioTitle-all-list/`, {params: params})
}


//评论管理-视频
export const dynamicCommentList = params => {
  return axios.get(`${host}/dynamic-comment-list/`, {params: params})
}
//评论管理-回复
export const dynamicCommentPost = parmas => {
  return axios.post(`${host}/dynamic-comment-post/`, parmas)
}
//评论管理-点赞
export const dynamicLike = params => {
  return axios.post(`${host}/dynamic-like/`, params)
}
//评论管理-举报
export const dynamicComplaint = parmas => {
  return axios.post(`${host}/dynamic-complaint/`, parmas)
}
//评论管理-删除
export const dynamicCommentDel = parmas => {
  return axios.post(`${host}/dynamic-comment-del/`, parmas)
}
//评论管理-详情
export const dynamicCommentRoot = params => {
  return axios.get(`${host}/dynamic-comment-root/`, {params: params})
}
//动态-详情
export const dynamicDetail = params => {
  return axios.get(`${host}/dynamic-detail/`, {params: params})
}
//动态-转发
export const dynamicShareList = params => {
  return axios.get(`${host}/dynamic-share-list/`, {params: params})
}
//动态转-分享
export const dynamicShare = parmas => {
  return axios.post(`${host}/dynamic-share/`, parmas)
}
//动态转-删除
export const dynamicDel = parmas => {
  return axios.post(`${host}/dynamic-del/`, parmas)
}
//已购视频
export const videoPayment = params => {
  return axios.get(`${host}/videopayment/`, {params: params})
}
//添加设备日志
export const userDevice = parmas => {
  return axios.post(`${host}/user-device/`, parmas)
}
//添加用户操作记录
export const userOperation = parmas => {
  return axios.post(`${host}/user-operation/`, parmas)
}
//举报-新
export const complaintAll = parmas => {
  return axios.post(`${host}/complaint-all/`, parmas)
}
//敏感词列表
export const sensitiveWords = params => {
  return axios.get(`${host}/sensitive-words/`, {params: params})
}
// 系统通知
export const usersManage = params => {
  return axios.get(`${host}/users/manage/`, {params: params})
}
// 系统通知归零
export const usersMaclear = params => {
  return axios.get(`${host}/users/maclear/`, {params: params})
}
// 论坛文章附件下载
export const articleFileDownload = params => {
  return axios.post(`${host}/forum/articleFileDownload/`, params)
}
// 论坛文章附件下载弹窗
export const articleFileDownloadPop = params => {
  return axios.post(`${host}/forum/articleFileDownloadPop/`, params)
}
// 文章、附件下载记录
export const articleFileDownloadList = (params) => {
  return axios.get(`${host}/forum/articleFileDownloadList/`, {params: params})
}
//网站展示开关
export const siteSwitch = (params) => {
  return axios.get(`${host}/site-switch/`, {params: params})
}

//app
let appHost = 'https://yookasi.com:9003'
// 商品详情
export const appShopDetail = (params) => {
  return axios.get(`${appHost}/goods/shopDetail/`, {params: params})
}
// 用户
export const userDetail = (params) => {
  return axios.get(`${appHost}/users/detail/`, {params: params})
}
// 用户
export const userHomeNumber = (params) => {
  return axios.get(`${appHost}/users/homeNumber/`, {params: params})
}
// 用户
export const homeGoodsList = (params) => {
  return axios.get(`${appHost}/users/homeGoodsList/`, {params: params})
}
// 用户
export const homeCommentList = (params) => {
  return axios.get(`${appHost}/users/homeCommentList/`, {params: params})
}
// 用户
export const homeDynamicList = (params) => {
  return axios.get(`${appHost}/users/homeDynamicList/`, {params: params})
}
// 安装包列表
export const appPackageList = (params) => {
  return axios.get(`${appHost}/AppPackageList/`, {params: params})
}

export default axios



// WEBPACK FOOTER //
// ./src/config/axiosUtil.js